var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ticket-management',{attrs:{"show-create":false},on:{"change":_vm.fetchData}},[_c('div',[_c('SeverityBoxes')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }